/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import Content from 'app/components/common/Content.jsx';
import DropDown from 'app/components/common/DropDown.jsx';
import FilterItem from 'app/components/DropDownItems/FilterItem.jsx';
import GenericItem from 'app/components/DropDownItems/GenericItem.jsx';
import ListActionButton from 'app/components/common/ListActionButton.jsx';
import SocialHeader from 'app/components/Headers/SocialHeader.jsx';
import SocialListItem from 'app/components/SocialLists/SocialListItem.jsx';
import SocialModal from 'app/components/SocialModal/SocialModal.jsx';
import * as _ from "underscore";
import UserMessages from 'app/modules/UserMessageModule.js';
import { Breakpoint } from 'react-socks';
import Loading from 'app/components/common/Loading.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { SOCIAL_CREATE, SOCIAL_DELETE, SOCIAL_UPDATE } from 'app/redux/constants.js';

const sortOptions = [
	{name: 'Last Post', key: 'lastPost.postTs', dir: 'DESC'},
	{name: 'Active', key: 'activeFlag', dir: 'DESC'},
	{name: 'Name A-Z', key: 'name', dir: 'ASC'},
	{name: 'Name Z-A', key: 'name', dir: 'DESC'}
];

class SocialConfig extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			socialId: (props.router.params.socialId) ? props.router.params.socialId : 0,
			socialDetail: {},
			duplicateSocial: {},
			bulkSocial: false,
			filterActive: false,
			filterLabel: '',
			sortActive: false,
			sortLabel: '',
			resetSearch: false,
			socialErrors: null,
			reauthorizing: false,
			modalUp: false,
			isDuplicateSocialModalVisible: false,
			listUrl: (props.appName === 'dlvr') ? '/config/socials' : '/socials',
			detailUrl: (props.appName === 'dlvr') ? '/config/socials/detail/' : '/socials/detail/',
			subaccountsLoaded: false,
			clientFilterRequestApplied: false,
			lastFilter: {},
			defaultSortApplied: false
		};

		this.showSocialDetail = this.showSocialDetail.bind(this);
		this.filterButtonClick = this.filterButtonClick.bind(this);
		this.filterSocials = this.filterSocials.bind(this);
		this.searchSocials = this.searchSocials.bind(this);
		this.sortButtonClick = this.sortButtonClick.bind(this);
		this.sortSocials = this.sortSocials.bind(this);
		this.connectSocial = this.connectSocial.bind(this);
		this.showBulkReauthDialog = this.showBulkReauthDialog.bind(this);
		this.resetDropdown = this.resetDropdown.bind(this);
		this.onSearchFocus = this.onSearchFocus.bind(this);
		this.getClientsForFilter = this.getClientsForFilter.bind(this);
		this.showTwitterWarning = this.showTwitterWarning.bind(this);
		this.onSocialCreated = this.onSocialCreated.bind(this);
		this.onSocialUpdated = this.onSocialUpdated.bind(this);
		this.onSocialDeleted = this.onSocialDeleted.bind(this);

		// Held rather than rebuilt: unregistering matches the object that registered.
		this.socialCallbacks = [
			{action: SOCIAL_CREATE, func: this.onSocialCreated},
			{action: SOCIAL_UPDATE, func: this.onSocialUpdated},
			{action: SOCIAL_DELETE, func: this.onSocialDeleted}
		];

	}

	static getDerivedStateFromProps(props, state) {
		let modalUp = state.modalUp;

		if (props.isDuplicateSocialModalVisible ||
			props.isBlacklistModalVisible ||
			props.isClientSocialModalVisible ||
			props.isUpgradeModalVisible ||
			props.isMovementRestrictedModalVisible) {
			modalUp = true;
		} else {
			modalUp = false;
		}

		return (modalUp !== state.modalUp) ? { modalUp } : null;

	}

	componentDidMount() {
		let state = '',
			socialId = this.state.socialId,
			stateParts = [],
			currentSort = this.props.socials.sort,
			constants = this.props.app.config.constants,
			reauthReturnPath = this.state.detailUrl + ":ID";

		this.props.clearFilter('socials');
		this.props.closeAllModals();

		this.socialCallbacks.map((callback) => { this.props.registerCallback(callback); });

		for (let i = 0; i < sortOptions.length; ++i) {
			if (sortOptions[i].key == this.props.socials.sort.key) {
				this.setState({
					sortLabel: sortOptions[i].name
				});
				break;
			}
		}

		this.props.getSocials();

		if (parseInt(this.props.user.perms.perms.clientSeats, 10) !== 0) {
			this.props.getSubaccounts({
				accountType: constants.SUB_CLIENT
			});
		}

		// get detail information if a social id is present
		if (this.state.socialId) {
			this.props.getSocial(socialId);
			reauthReturnPath = reauthReturnPath.replace(":ID", socialId);
		}

		// only run the reauth on mount, new social creates can run into
		// a race condition so let the social list load and then
		// send up the create command if a state value is present in the URL
		this.props.remoteReturnHandler([{
			method: 'REAUTH',
			path: reauthReturnPath,
			callback: () => {
				this.setState({
					reauthorizing: true
				});
			}
		}]);

		// if (this.props.router.query !== null && this.props.router.query.state) {
		// 	state = this.props.router.query.state || '';
		// 	if (this.state.socialId || state.match(/REAUTH/)) {
		// 		if (state.match(/REAUTH/)) {
		// 			let stateParts = state.split("_");
		// 			socialId = stateParts[2];
		// 			this.setState({
		// 				socialId: socialId,
		// 				token: state,
		// 				reauthorizing: true
		// 			});
		// 		}
		// 		this.props.authReturnHandler({
		// 			path: this.state.detailUrl + socialId
		// 		});
		// 		this.props.getSocial(socialId);
		// 	} else {
		// 		this.props.authReturnHandler({
		// 			path: this.state.listUrl
		// 		});
		// 	}
		// }

		// in client scenario ClientApp has initiated the social load so we can count
		// on them being present
		if (this.props.appName === "client" && this.props.socials.list.length === 0 && state === '' && Object.keys(this.props.socials.batchCreates).length === 0) {
			if (this.props.user.detail.needsPassword === false) {
				this.connectSocial();
			}
		}

		if (this.props.router.query && this.props.router.query.add !== undefined && this.state.modalUp === false) {
			if (this.props.router.query && this.props.router.query.redirect !== undefined) {
				this.props.persistData("connectRedirect", this.props.router.query.redirect);
			}

			window.history.pushState("", "dlvr.it", "/config/socials");
			this.connectSocial();
		}

	}

	componentWillUnmount() {
		this.socialCallbacks.map((callback) => { this.props.unregisterCallback(callback); });
	}

	componentDidUpdate(prevProps, prevState) {

		if ((this.props.router.query && this.props.router.query.add !== undefined) &&
			this.state.modalUp === false) {
			window.history.pushState("", "dlvr.it", "/config/socials");
			this.connectSocial();
		}

		if (prevState.socialId === 0 && this.state.socialId !== 0) {
			this.props.getSocial(this.state.socialId);
		}

		if (prevProps && prevProps.router.params.socialId === undefined && this.props.router.params.socialId !== undefined) {
			this.setState({
				socialId: this.props.router.params.socialId
			});
		}

		let constants = this.props.app.config.constants,
			loginTypes = [constants.POST_SVC_BLUESKY];

		const clearSocialErrors = () => {
			this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
		}

		const setSocialError = () => {
			let socialError = this.props.getErrorForSocial(this.state.socialId);
			if (socialError) {
				this.setState({
					socialErrors: socialError
				});
			}
		};

		if (this.props.isDuplicateSocial() && !this.state.modalUp) {
			if (this.state.bulkSocial) {
				this.props.closeAllModals();
			}

			let duplicateSocial = {};
			if (this.state.socialId) {
				duplicateSocial = {
					'id': this.state.socialId,
					'activeFlag': 1,
					'force': 1,
					'psID': this.props.authState.credID.split("_")[1]
				};
				if (this.props.authState.credID) {
					duplicateSocial.credID = this.props.authState.credID;
				}
				if (loginTypes.indexOf(duplicateSocial.psID)) {
					for (let i = 0; i < this.props.app.errors.api.length; ++i) {
						if (this.props.app.errors.api[i].type === 'SOCIAL_UPDATE') {
							duplicateSocial.creds = this.props.app.errors.api[i].post.creds;
						}
					}
				}
			} else {
				// the post for the last action is in the error. for the time being
				// just dig it out of the errors
				for (let i = 0; i < this.props.app.errors.api.length; ++i) {
					if (['SOCIAL_UPDATE', 'SOCIAL_CREATE'].indexOf(this.props.app.errors.api[i].type) !== -1) {
						duplicateSocial = this.props.app.errors.api[i].post;
					}
				}
				duplicateSocial.force = 1;
			}

			this.props.showDuplicateSocialModal(duplicateSocial, {
				confirm: clearSocialErrors,
				cancel: clearSocialErrors
			});

			setSocialError();

		} else if (this.props.isOverTheLimit() && !this.state.modalUp) {
			let errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
			if (this.props.appName === "dlvr") {
				this.props.showUpgradeModal(() => {
					this.props.closeAllModals();
				}, null, errors, 'social_error');
			} else {
				this.props.showClientSocialModal({
					confirm: clearSocialErrors
				});
			}
			setSocialError();
			clearSocialErrors();
		} else if ((this.props.isMovementRestricted() || this.props.isBlacklisted()) && !this.state.modalUp) {
			if (this.props.isBlacklisted()) {
				this.props.showBlacklistModal({
					confirm: clearSocialErrors,
					cancel: clearSocialErrors
				});
			} else {
				this.props.showMovementRestrictedModal({
					confirm: clearSocialErrors,
					cancel: clearSocialErrors
				});
			}
			setSocialError();
		}

		if (prevState.reauthorizing === true && this.state.reauthorizing === true) {
			this.setState({
				reauthorizing: false
			}, () => {
				this.props.addMessage(UserMessages.generateMessage(UserMessages.social.reauthorized, 'SOCIAL_UPDATE'));
			});
		}

		let social = this.props.findSocial(this.state.socialId);
		if (social && social.inactiveCount !== undefined && social.inactiveCount > 0 && this.state.bulkSocial === false) {
			// if we return after the call, then the next time update is called
			// on social update we can fall through and reset the token and modalUp state
			this.showBulkReauthDialog();
			this.setState({
				bulkSocial: true
			});
			return;
		}

		// A call to getSocials that gets the stored list won't toggle the loading flags
		// in the usual manner, so check if the SOCIAL_LIST has been loaded and if there's
		// a state value in query... then create the social
		if ((this.props.app.firstLoad.SOCIAL_LIST || this.props.app.SUBACCOUNT_LIST) &&
			this.props.router.query !== null && this.props.router.query.state) {
			this.props.remoteReturnHandler([{
				method: 'POST',
				path: this.state.listUrl,
				callback: null
			}]);
		}

		if (this.props.app.firstLoad.SOCIAL_LIST && this.state.defaultSortApplied === false) {
			this.sortSocials(sortOptions[1]);
			this.setState({
				defaultSortApplied: true
			});
		}

		// if a user is redirected to a deleted social, or has a link to a deleted social,
		// move them back to the list
		// Also check for SUBACCOUNT_LIST load because ClientApp also loads the socials so the
		// SOCIAL_LIST load signal is sent before this component is loaded
		if ((prevProps.app.loading.SOCIAL_LIST === true && this.props.app.loading.SOCIAL_LIST === false) ||
			(prevProps.app.loading.SUBACCOUNT_LIST === true && this.props.app.loading.SUBACCOUNT_LIST === false)) {
			if (this.state.socialId) {
				if (_.findWhere(this.props.socials.list, {'id': parseInt(this.state.socialId, 10)}) === undefined) {
					this.setState({
						socialId: 0
					});
					this.props.router.navigate(this.state.listUrl);
				}
			}

			// load the social detail AFTER the social list is loaded so the detail
			// doesn't get clobbered
			if (this.state.socialId) {
				this.props.getSocial(this.state.socialId);
			}
		}

		if (prevProps.app.loading.SUBACCOUNT_LIST === true && this.props.app.loading.SUBACCOUNT_LIST === false) {
			if (this.state.subaccountsLoaded === false) {
				this.setState({
					subaccountsLoaded: true
				});
			}
		}

		if (this.props.socials.list.length &&
			this.state.subaccountsLoaded === true &&
			this.props.router.query && this.props.router.query.client !== undefined) {
			if (this.state.clientFilterRequestApplied === false) {
				let subaccount = this.props.subaccounts.list.find((item) => { return item.id === parseInt(this.props.router.query.client); });
				if (subaccount) {
					this.filterSocials({
						id: parseInt(this.props.router.query.client),
						name: subaccount.clientName
					});
					this.setState({
						clientFilterRequestApplied: true
					});
				}
			}
		}

	}

	showSocialDetail(e) {
		let id = e.currentTarget.getAttribute('data-id');

		// clear messages for social
		this.props.deleteMessage(['SOCIAL_UPDATE', 'SOCIAL_CHECK_AUTH']);

		//second click on row closes the detail
		if (id === this.state.socialId) {
			this.props.router.navigate(this.state.listUrl);
			this.setState({
				socialId: 0,
			});
		} else {
			this.props.getSocial(id);
			this.props.router.navigate(this.state.detailUrl + id);
			this.setState({
				socialId: id,
			});
		}


	}

	filterButtonClick(e) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			filterActive: !this.state.filterActive
		});
	}

	filterSocials(filter) {
		let exact = false,
			keys = ['psID'],
			type = (filter.type !== undefined) ? filter.type.toString() : '';

		if (filter.type !== '') {
			exact = true;
		}

		if (filter.id !== undefined) {
			exact = true;
			keys = ['clientPubID'];
			type = filter.id.toString(); // cast for the filter code
		}

		this.props.filterStore('socials', keys, type, exact);

		this.setState({
			filterLabel: filter.name,
			filterActive: false,
			lastFilter: filter
		});
	}

	searchSocials(e, search) {

		this.props.filterStore('socials', ['name'], search);

	}

	sortButtonClick(e) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			sortActive: !this.state.sortActive
		});
	}

	sortSocials(sort, e) {

		this.props.sortStore('socials', sort.key, sort.dir);

		this.setState({
			sortActive: false,
			sortLabel: sort.name
		});
	}

	connectSocial() {

		let modal = (
				<SocialModal
					{...this.props}
					router={this.props.router}
					context={'config'}
					recordPath={this.props.recordPath}
					user={this.props.user} />
			);

		if (this.props.appName !== "client" && this.state.socialId) {
			this.props.router.navigate("/config/socials");
		}


		if (this.props.user.perms.resources.outputsAvailable == 0) {
			if (this.props.appName === "dlvr") {
				this.props.showUpgradeModal(this.props.closeAllModals, 'socials', null, 'social_banner');
			} else {
				modal = (
					<ConfirmModal
						modalCopy={"Sorry, we're unable to create a new social for you. Please contact " + this.props.user.detail.clientInfo.organization + " to help resolve this issue."}
						confirmLabel="OK"
						closeAction={() => {
							this.setState({
								modalUp: false
							});
							this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
							this.props.closeAllModals();
						}}
						confirmAction={() => {
							this.setState({
								modalUp: false
							});
							this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
							this.props.closeAllModals();
						}}
						showCancel={false}/>
				);
				this.props.addModal(modal);
			}
		} else {
			this.props.addModal(modal);
		}

		this.props.clearFilter('socials');

		this.setState({
			resetSearch: true,
			filterActive: false,
			filterLabel: '',
			socialId: 0
		});

	}

	showTwitterWarning() {
		let modal = (
			<ConfirmModal
				modalCopy="Twitter is currently unavailable. We're working to resolve this issue."
				cancelAction={() => {
					this.props.closeAllModals();
				}}
				showCancel={false}
				confirmAction={() => {
					this.props.closeAllModals();
				}}
				confirmLabel={"OK"}/>
		);

		this.props.addModal(modal);
	}

	/*
	 * A connect finished on this page.
	 *
	 * The modals are only closed over a feed output: anything else can turn out
	 * to need a takeover, and the modal is where that gets asked, so it stays up.
	 * A feed can't, which is what makes it the one safe case.
	 *
	 * The optional-function checks are for the client app, which connects socials
	 * but has no feed interface — App.jsx injects those props in dlvr only, and
	 * the optimizer has been seen calling through a missing one rather than
	 * short-circuiting, hence the catch.
	 */
	onSocialCreated(detail) {
		let constants = this.props.app.config.constants,
			newSocial = detail.social,
			suggestFeedsExcluded = false,
			redirect = null;

		this.props.getUserPerms();

		if (!newSocial) {
			return;
		}

		if (newSocial.psID === constants.POST_SVC_FEED) {
			this.props.closeAllModals();
		}

		if (newSocial.psID && [constants.POST_SVC_INSTAGRAM_BUSINESS, constants.POST_SVC_FACEBOOK, constants.POST_SVC_TIKTOK].indexOf(newSocial.psID) !== -1) {
			if (typeof this.props.getSocialInputCreds === "function") {
				try {
					this.props.getSocialInputCreds();
				} catch (e) {
					// see the note above about the client app
				}
			}
		}

		/*
		 * The picker is suppressed for the same social types whose entry point
		 * SocialListDetail hides: an instagram business account is offered feeds
		 * through its own flow, and a feed output publishes a feed rather than
		 * consuming one.
		 */
		suggestFeedsExcluded = [constants.POST_SVC_INSTAGRAM_BUSINESS, constants.POST_SVC_FEED].indexOf(parseInt(newSocial.psID, 10)) !== -1;

		if (!suggestFeedsExcluded && this.props.appName !== "client"
			&& typeof this.props.userHasFeeds === "function"
			&& typeof this.props.showSuggestFeedsModal === "function"
			&& this.props.userHasFeeds()) {
			this.props.showSuggestFeedsModal(newSocial.id);
		}

		// set up a redirect for the stats analyzer tile
		redirect = this.props.getPersistedData("connectRedirect");
		if (redirect) {
			this.props.clearPersistedData("connectRedirect");
			this.props.router.navigate(redirect);
		}

	}

	/*
	 * A reauthorization came back, and only a reauthorization: `authState.credID`
	 * is what says this update started from a connect return rather than from
	 * someone editing an account, and an ordinary edit has nothing to tear down.
	 *
	 * The inactiveCount guard mirrors the early return in componentDidUpdate. An
	 * account whose credentials are shared with other switched-off accounts raises
	 * the bulk dialog instead, and the pass that raises it must not also close it.
	 */
	onSocialUpdated() {
		let social = this.props.findSocial(this.state.socialId),
			hasErrors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']).length ? true : false;

		if (hasErrors || !this.props.authState.credID) {
			return;
		}

		if (social && social.inactiveCount !== undefined && social.inactiveCount > 0 && this.state.bulkSocial === false) {
			return;
		}

		if (this.state.bulkSocial === true) {
			this.props.getSocials(true);
		}

		if (social && social.inactiveCount !== undefined && social.inactiveCount === 0) {
			this.props.resetAuthState();
		}

		this.setState({
			bulkSocial: false,
			modalUp: false
		});

		this.props.closeAllModals();
		this.props.getUserPerms();

	}

	/*
	 * The list is filtered in redux, so a removal has to be reapplied against the
	 * shorter list or the filtered view keeps drawing the account that is gone.
	 */
	onSocialDeleted() {
		if (Object.keys(this.state.lastFilter).length) {
			this.filterSocials(this.state.lastFilter);
		}

		this.props.getUserPerms();

	}

	showBulkReauthDialog() {
		let serviceName = ConstantMixin.getPostServiceNameByCode(this.state.socialDetail.psID),
			modalCopy = 'Would you like to reactivate the socials connected with this ' + serviceName + ' account?',
			cancel = () => {
				let social = {
					'id': this.state.socialId,
					'activeFlag': 1,
					'enableAll': 0
				}
				this.props.closeAllModals();
				// call updateSocial to clear the
				this.props.updateSocial(social);
			},
			confirm = () => {
				let social = {
					'id': this.state.socialId,
					'activeFlag': 1,
					'enableAll': 1
				}
				if (this.props.authState.credID) {
					social.credID = this.props.authState.credID;
				}
				this.props.updateSocial(social);
			};

		let modal = (
			<ConfirmModal
				modalCopy={modalCopy}
				cancelAction={cancel}
				confirmAction={confirm}
				context="bulkReauth" />
		);

		this.props.addModal(modal);

	}

	resetDropdown(which) {

		let filterActive = this.state.filterActive,
			sortActive = this.state.sortActive;

		if (which === 'filter') {
			filterActive = false;
		} else if (which === 'sort') {
			sortActive = false;
		}

		this.setState({
			filterActive,
			sortActive
		});

	}

	onSearchFocus() {

		this.setState({
			resetSearch: false
		});

	}

	getClientsForFilter() {
		let subaccounts = [];

		for (let i = 0; i < this.props.subaccounts.list.length; ++i) {
			let count = this.props.socials.list.filter((social) => { return social.clientPubID === this.props.subaccounts.list[i].id; }).length;
			if (count) {
				subaccounts.push({
					type: "",
					id: this.props.subaccounts.list[i].id,
					name: this.props.subaccounts.list[i].clientName,
					count
				});
			}
		}

		return subaccounts;
	}

	render() {
		let header = null,
			main = null,
			filterLabel = (this.state.filterLabel === '') ? 'All Outputs' : this.state.filterLabel,
			headerSort = null,
			filterDropdown = null,
			sortDropdown = null,
			actionButton = null,
			emptyState = null,
			socials = (this.props.socials.filter !== undefined) ? this.props.socials.filteredList : this.props.socials.list;

		if (Object.keys(this.props.socials.counts).length === 0) {
			filterLabel = '\u00a0';
			if (this.props.app.firstLoad.SOCIAL_LIST === false) {
				emptyState = (
					<Loading label="Loading your socials"/>
				);
			} else if (this.props.appName === "dlvr") {
				emptyState = (
					<div className="socials-empty">Connect your first output to start sharing great content.</div>
				);
			} else {
				emptyState = (
					<div className="socials-empty">Connect your first output for {this.props.user.detail.clientInfo.organization} to manage.</div>
				);
			}
		}

		actionButton = (
			<div className="control new" onClick={this.connectSocial} role="button" aria-label="add social">
				<span className="va-helper"></span>
				<i className="fa fa-plus-square new-icon"></i> Add Output
			</div>
		);

		if (this.state.filterActive) {
			let items = _.clone(this.props.socials.counts);

			if (this.props.subaccounts.list.length && this.props.user.detail.isClient === false) {
				let subFilters = this.getClientsForFilter(),
					allSocials = items.pop();

				 items = items.concat(subFilters);
				 items.push(allSocials);
			}

			filterDropdown = (
				<DropDown
					id="filter"
					items={items}
					itemElement={FilterItem}
					clickHandler={this.filterSocials}
					dropDownClass="filter-dd"
					resetHandler={this.resetDropdown} />
			);
		}

		if (this.state.sortActive) {
			sortDropdown = (
				<DropDown
					id="sort"
					items={sortOptions}
					itemElement={GenericItem}
					clickHandler={this.sortSocials}
					dropDownClass="sort-dd short"
					resetHandler={this.resetDropdown} />
			);
		}

		header = (
			<SocialHeader
				{...this.props}
				filterButtonCallback={this.filterButtonClick}
				filterLabel={filterLabel}
				filterDropdown={filterDropdown}
				searchCallback={this.searchSocials}
				actionButton={actionButton}
				sortLabel={this.state.sortLabel}
				sortButtonCallback={this.sortButtonClick}
				sortDropdown={sortDropdown}
				resetSearch={this.state.resetSearch}
				focusHandler={this.onSearchFocus}
				user={this.props.user} />
		);

		main = (
			<div>
				<ul className="dlvr-list-component">
					{socials.map(function(social, i){
						let detail = null,
							showDetail = (parseInt(this.state.socialId, 10) === social.id);

						return (
							<SocialListItem
								{...this.props}
								key={social.id}
								social={social}
								detailHandler={this.showSocialDetail}
								showDetail={showDetail}
								showTwitterWarning={this.showTwitterWarning}
								socialErrors={this.state.socialErrors} />
						);
					}, this)}
				</ul>
				{emptyState}
				<Breakpoint desktop only>
					<ListActionButton
						buttonLabel="Add Output"
						action={this.connectSocial} />
				</Breakpoint>
			</div>
		);

		return (
			<Content header={header} main={main}/>
		);
	}
};

SocialConfig.displayName = "SocialConfig";

SocialConfig.propTypes = {
	recordPath: PropTypes.func,
	appName: PropTypes.string,
	showSuggestFeedsModal: PropTypes.func,
	userHasFeeds: PropTypes.func
};

SocialConfig.defaultProps = {
	recordPath: null,
	appName: 'dlvr',
	showSuggestFeedsModal: null,
	userHasFeeds: null
};

export default ComponentWithContext(SocialConfig);
